<template>
  <div class="product-parameter">
    <div class="row">
      <div class="left-content col-md-7">
        <div v-if="isEn =='0'" class="title">产品参数</div>
        <div v-if="isEn =='1'" class="title">Parameters</div>
        <div v-for="item in parameter" class="" :key="item.uuid">
          <span>{{ item.paramName }}:</span>
          <span v-html="item.paramValue">{{ item.paramValue }}</span>
        </div>
      </div>
      <div class="right-content col-md-5">
        <div
          class="case-content"
          v-show="
            productCaseList && productCaseList[0] && productCaseList[0].value
          "
        >
          <div class="title" v-if="isEn =='0'">典型案例</div>
          <div class="title" v-if="isEn =='1'">Typical instance</div>
          <div class="download-list">
            <div
              class="download-list-item"
              v-for="(item, index) in productCaseList"
              :key="index"
            >
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "productparameter",
  props: ["parameter", "productCase"],
  components: {},
  data() {
    return {
      isEn:'0',
    };
  },
  created() {
    this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0');
  },
  computed: {
    productCaseList() {
      if (this.productCase == "") {
        return "{}";
      } else {
        return JSON.parse(this.productCase);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.product-parameter {
  min-width: 900px;
  margin-top: 60px;
  padding: 70px 0px;
  // width: 90%;
  margin: 0 auto;
  .left-content {
    padding: 10px 10px 10px 0;
    padding-right: 80px;
    & > div {
      // height: 46px;
      line-height: 46px;
      font-size: 14px;
      color: #2c2c2c;
      // padding-left: 10px;
      & > span:nth-child(1) {
        display: inline-block;
        width: 145px;
        font-weight: 600;
        text-align: left;
        vertical-align: top;
      }
      & > span:nth-child(2) {
        display: inline-block;
        width: calc(100% - 150px);
      }
    }
    .title {
      height: 60px;
      line-height: 60px;
      font-size: 24px;
      color: #2c2c2c;
      margin-bottom: 18px;
      // width:77.2%;
      padding-left: 0;
    }
  }
  .right-content {
    .download-content {
      padding: 10px 0;
      .download-list {
        .download-list-item {
          height: 75px;
          line-height: 75px;
          border-bottom: 1px solid #ebebeb;
          // padding-left: 10px;
          .download-btn {
            cursor: pointer;
            float: right;
            color: #3bbde7;
            font-size: 14px;
            .downloadSpan {
              font-size: 14px;
              color: #3bbde7;
              cursor: pointer;
            }
            .downloadSpan:hover {
              color: #22a6d1;
            }
          }
        }
      }
    }
    .case-content {
      margin-top: 10px;
      // padding: 10px;
      font-size: 14px;
      line-height: 28px;
      .download-list {
        // padding-left: 10px;
        margin-top: 23px;
        .download-list-item {
          font-size: 14px;
          line-height: 28px;
          //     height: 50px;
          //     line-height: 50px;
        }
      }
    }
  }
  .title {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #ebebeb;
    // padding-left: 5px;
    font-size: 24px;
    color: #2c2c2c;
    // padding-left: 10px;
  }
}
@media only screen and (max-width: 991px) and (min-width:320px) {
.product-parameter .left-content{
      padding: 0px !important;
  }
.product-parameter .left-content > div > span:nth-child(1) {
    width: 40% !important;
    display: block !important;
    font-weight: 900 !important;
  }
   .col-md-90 > .product-parameter {
    min-width: 0px !important;
  }
  .product-parameter .left-content > div > span:nth-child(2) {
    display: block !important;
    width:100% !important
  }
  .row .left-content > .title{
      font-size: 18px;
    }
    .right-content .case-content .title{
      font-size: 18px !important;

    }
}
</style>




// WEBPACK FOOTER //
// src/components/ProductParameter.vue